import React from 'react';
import { Link } from 'react-router-dom';
import { company } from '../../data/site';
export function Footer() {
  return <footer className="border-t border-line bg-canvas-deep" data-id="element-139" data-mp="3aghsgrsdrran">
      <div className="mx-auto max-w-content px-5 py-12 lg:px-8" data-id="element-140" data-mp="2wg71lor2mcph">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between" data-id="element-141" data-mp="2wi1mx46986u3">
          <div data-id="element-142" data-mp="31fjxt03u0w4q">
            <img src={company.logoWide} alt="LYKKEVÆRK" className="h-12 w-auto md:h-14" data-id="element-143" data-mp="31fa3x1fo24tr" />
            <p className="mt-4 text-[15px] text-ink-soft" data-id="element-144" data-mp="3p5e9vfgbugnx">{company.tagline}</p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-145" data-mp="3u2e3urzwjsyo">CVR: {company.cvr}</p>
          </div>

          <div className="flex flex-col gap-2 text-[15px] md:items-end" data-id="element-146" data-mp="3fdrrmz5knhbo">
            <a href={company.phoneHref} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-147" data-mp="3kdme8qibdkqx">
              {company.phone}
            </a>
            <a href={`mailto:${company.email}`} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-148" data-mp="bvzuz7ghq975">
              {company.email}
            </a>
            <div className="mt-3 flex gap-5 text-sm text-ink-muted" data-id="element-149" data-mp="3eght3wl6uk3k">
              <a href="#kontakt" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-150" data-mp="3eicf7e874i98">
                Kontakt
              </a>
              <a href="#privatliv" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-151" data-mp="3ngo51e18nc0m">
                Privatlivspolitik
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-line pt-6 text-sm text-ink-muted" data-id="element-152" data-mp="12eizbks6g30">
          <p data-id="element-153" data-mp="f0uqh4qgwam7">© {new Date().getFullYear()} LYKKEVÆRK</p>
          <Link to="/admin/login" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-154" data-mp="az9gps98ccg8">
            Admin
          </Link>
        </div>
      </div>
    </footer>;
}